window.addEventListener("DOMContentLoaded", () => {
    const btnElement = document.querySelectorAll('.btn')
    let activeClick = () => {
        if(btnElement){
            btnElement.forEach((el) => {
                let activeElement = document.createElement('span')
                activeElement.classList.add('activeElement')
                el.appendChild(activeElement);
                el.addEventListener("click", (e) => {
                    if (e.currentTarget.getAttribute('data-bs-toggle') === 'collapse') return
                    
                    let rect = e.currentTarget.getBoundingClientRect()
                    let x = e.clientX - rect.left;
                    let y = e.clientY - rect.top;
                    activeElement.classList.add('active')
                    activeElement.style.left = x + "px" 
                    activeElement.style.top = y + "px"
                    setTimeout(function(){
                        activeElement.classList.remove('active')
                    }, 300)
                })
            })
        }
    }
    activeClick()
})